export default __webpack_public_path__ + "static/media/book_image7.a36b834c.jfif";